import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

/**
 * Creates (or reuses) the DocuSign envelope for an accepted à la carte bid and
 * returns an embedded signing URL for the current portal user.
 *
 * @param {string} bidId
 * @returns {Promise<{ envelopeId: string, signingUrl: string, reused?: boolean }>}
 */
export async function startBidContractSigning(bidId) {
  if (!bidId) throw new Error('bidId is required');
  const createEnvelope = httpsCallable(functions, 'createBidContractEnvelope');
  const result = await createEnvelope({ bidId });
  return result.data;
}
